/**
 *
 * CustomDate
 *
 */

import React, { memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { Form } from "antd";
import { DatePicker } from "../../../CustomAntdPickers/CustomAntdPickers";

function CustomDate({
  format,
  label,
  name,
  value,
  required,
  initialValue,
  disabled,
  loading,
  todayLabel,
  nowLabel,
  // actions
  disabledDate,
  onChange,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames("tcf-date-wrapper", className);
  const { t } = useTranslation();

  return (
    <Form.Item
      className={childClassNames}
      key={`${name}-date-select`}
      label={!!label && label || t("inputs.date")}
      name={name}
      loading={!!loading}
      initialValue={initialValue}
      rules={[
        {
          required: required,
          message: t("inputs.selectRequiredField"),
        },
      ]}
      {...rest}
    >
      <DatePicker
        mode={"date"}
        onChange={onChange}
        disabledDate={disabledDate}
        format={format}
        value={value}
        disabled={!!disabled}
      />
    </Form.Item>
  );
}

CustomDate.defaultProps = {
  required: true,
  disabled: false,
  loading: false,
  format: "DD.MM.YYYY"
};
CustomDate.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  format: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  disabledDate: PropTypes.func,
};

export default memo(CustomDate);
